import { Box, Typography, Pagination, useMediaQuery, useTheme } from "@mui/material";
import { MetaData } from "../models/pagination";

interface Props {
  metaData: MetaData;
  onPageChange: (page: number) => void;
}

const AppPagination: React.FC<Props> = ({ metaData, onPageChange }) => {
  const { currentPage, totalCount, totalPages, pageSize } = metaData;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const paginationLabel =
    totalCount === 0
      ? "Displaying 0 of 0 items"
      : `Displaying ${(currentPage - 1) * pageSize + 1}-${
          currentPage * pageSize > totalCount ? totalCount : currentPage * pageSize
        } of ${totalCount} items`;

  return (
    <Box
      display="flex"
      justifyContent={isMobile ? "center" : "space-between"}
      alignItems="center"
      flexDirection={isMobile ? "column" : "row"}
      gap={1}
      mt={2}
    >
      <Typography variant="body2" align={isMobile ? "center" : "inherit"}>
        {paginationLabel}
      </Typography>
      <Pagination
        color="primary"
        size={isMobile ? "medium" : "large"}
        count={totalPages}
        page={currentPage}
        onChange={(event, page) => onPageChange(page)}
      />
    </Box>
  );
};

export default AppPagination;